/** Local testing NPI — set USE_UM_TEST_NPI to false for production release */
export const UM_TEST_PROVIDER_NPI = "dr-khush-singh";
export const USE_UM_TEST_NPI = false;

export const getUmProviderNpi = (actualNpi: string): string =>
  USE_UM_TEST_NPI ? UM_TEST_PROVIDER_NPI : actualNpi;

export const UM_API_STATUS = {
  OPEN: "physician_advisor_approved",
  COMPLETED: "provider_responded",
} as const;

export const UM_DISPLAY_STATUS = {
  [UM_API_STATUS.OPEN]: "Open",
  [UM_API_STATUS.COMPLETED]: "Completed",
} as const;

export const UM_RESPONSE_STATUS = {
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
} as const;

export const UM_STATUS_FILTER_OPTIONS = [
  { value: UM_API_STATUS.OPEN, label: "Open" },
  { value: UM_API_STATUS.COMPLETED, label: "Completed" },
];

export const UM_OTHER_OPTION_ID = "option-2";
